'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _constants = require('../constants');

var _executors = require('./executors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchCupidAndLoadWatcher].map(_regenerator2.default.mark);

function fetchCupidAndLoadWatcher() {
  return _regenerator2.default.wrap(function fetchCupidAndLoadWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.FETCH_CUPID_AND_LOAD, _executors.fetchCupidAndLoadExecutor);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

var sagas = [fetchCupidAndLoadWatcher];

exports.default = sagas;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/cupid/sagas/index.js
// module id = 3442
// module chunks = 2